module.exports = __webpack_public_path__ + "img/go-pc-advanced-edition.b1c721cd.png";